@if (isPlanned) {
  <div class="plan-data-locked-banner" role="status">
    <i class="pi pi-lock" aria-hidden="true"></i>
    <span>{{ 'SEASON_PLAN_DATA_LOCKED_BANNER' | translate }}</span>
  </div>
}

<app-data-table
  [columns]="tableColumns"
  [data]="data"
  [config]="tableConfig"
  [totalRecords]="data.length"></app-data-table>

@if (!isPlanned && harvestDateError()) {
  <div class="validation-error">
    <span class="error-text">{{ harvestDateError() }}</span>
  </div>
}

@if (isPlanned && harvestDatePlanError()) {
  <div class="validation-error">
    <span class="error-text">{{ harvestDatePlanError() }}</span>
  </div>
}

<ng-template
  #PlannedTemplate
  let-row>
  <div class="plan-column-locked">
    @if (row?.type === "select-crop") {
      <msf-select-paginated
        [(ngModel)]="model[row?.modelField1]"
        [service]="cropService"
        [serviceMethod]="'dictionariesCropGetByQueryPost'"
        [placeholder]="'Select' | translate"
        [disabled]="true"
      ></msf-select-paginated>
    } @else if (row?.type === "select-variety") {
      <msf-select-paginated
        [(ngModel)]="model[row?.modelField1]"
        [service]="varietyService"
        [serviceMethod]="'dictionariesVarietyGetByQueryPost'"
        [placeholder]="'Select' | translate"
        [filter]="plannedVarietyFilter"
        [disabled]="true"
      ></msf-select-paginated>
    } @else if (row?.type === "date") {
      <app-date-picker
        [(ngModel)]="model[row?.modelField1]"
        [placeholder]="'Select date' | translate"
        [disabled]="true"></app-date-picker>
    } @else if (row.type === "number") {
      <app-input
        type="number"
        [(ngModel)]="model[row?.modelField1]"
        [disabled]="true" />
    }
  </div>
</ng-template>

<ng-template
  #FactTemplate
  let-row>
  @if (row?.type === "select-crop") {
    <msf-select-paginated
      [(ngModel)]="model[row?.modelField2]"
      [service]="cropService"
      [serviceMethod]="'dictionariesCropGetByQueryPost'"
      [placeholder]="'Select' | translate"
      (ngModelChange)="onFieldChange(row, 'actual')"
    ></msf-select-paginated>
  } @else if (row?.type === "select-variety") {
    <msf-select-paginated
      [(ngModel)]="model[row?.modelField2]"
      [service]="varietyService"
      [serviceMethod]="'dictionariesVarietyGetByQueryPost'"
      [placeholder]="'Select' | translate"
      [filter]="actualVarietyFilter"
    ></msf-select-paginated>
  } @else if (row?.type === "date") {
    <app-date-picker
      [(ngModel)]="model[row?.modelField2]"
      [placeholder]="'Select date' | translate"
      (ngModelChange)="onDateChange()"
      [disabled]="row.readonly"></app-date-picker>
  } @else if (row.type === "number") {
    <app-input
      type="number"
      [(ngModel)]="model[row?.modelField2]"
      (ngModelChange)="onFieldChange(row, 'actual')"
      [disabled]="row.readonly" />
  }
</ng-template>
